import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import { Col, Container, Row } from '../../../ui/gridSystem';
import {
  Category, ProductCoursesContainer, Description, ProductCoursesListContainer,
  HeaderContainer, HeaderInfoContainer, Iframe, MainSection, ProgressContainer,
  ProgressWrapper, ProductCourseHeader, ProductCourseClock,
  ProductCourseHeaderLength, ProductCourseHeaderDuration, ProductCourseList,
  VideoContainer, VideoInfo, VideoInfoWrapper,
  VideoSocialWrapper, Like, Social, ProductCoursesListCount,
  Info, ExpireDate, Frame, SocialTitle, ButtonContainer, CourseNotAvailable,
} from './style';

import { BackButton, ProgressBar } from '../../../ui/atoms';
import routes from '../../../routes';
import { Comments, LearningObjectCard } from '../../../ui/components';
import Arial from '../../../ui/typography/arial';
import Button from '../../../ui/atoms/Button';
import { durationConvert, getExactLabel } from '../../../utils/common';
import { getValueVocabulary } from '../../../utils/getValueVocabulary';
import HtmlRaw from '../../../ui/atoms/HtmlRaw';
import dateFormat from '../../../utils/date-format';
import { isArabic } from '../../../utils/locale';

import {
  ACADEMY_COURSE_DETAILS_SET_VIEWS,
  ACADEMY_DETAILS_GET,
  ACADEMY_LO_SET_COMMENT,
  ACADEMY_LO_SET_LIKEDISLIKE,
  ACADEMY_LO_SET_VIEWS,
  ACADEMY_LO_UNSET,
} from '../../redux/actions/academy';

const AcademyDetails = ({
  course_id,
  lo_id,

  // state
  course_details: data,
  vocabulary,
  contentNotAvailable,
  location,

  // dispatchers
  getAcademyDetails,
  resetAcademyDetails,
  setLikeDislike,
  setAcademyDetailsCourseViews,
  setLOViews,
  setComment,
  pushUrl,
}) => {
  const [selectedLO, setSelectedLO] = useState(null);
  const [scormFullscreen, setScormFullscreen] = useState(false);
  const [scormFrameIsLoaded, setScormFrameIsLoaded] = useState(false);

  // mostra il corso se ha il flag academy (supporta sia is_academy che isAcademy)
  const [showCourse, setShowCourse] = useState(false);
  useEffect(() => {
    const isAcademyFlag = (data?.is_academy ?? data?.isAcademy);
    // se il flag non è presente, non bloccare: mostra il corso
    setShowCourse(isAcademyFlag === undefined ? true : Boolean(isAcademyFlag));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, location]);

  // mount/unmount
  useEffect(() => {
    window.scrollTo(0, 0);
    getAcademyDetails(course_id);
    return () => resetAcademyDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course_id]);

  // selezione default LO + tracking views corso
  useEffect(() => {
    const lo_list = Array.isArray(data?.lo_list) ? data.lo_list : [];

    if (Object.keys(data || {}).length > 0 && !(data?.user_actions?.views)) {
      setAcademyDetailsCourseViews(course_id);
    }

    if (lo_list.length > 0) {
      const isCourseCompleted =
        lo_list.filter(item => item.status !== 'completed' && item.status !== 'passed').length === 0;

      const selectedFromUrl = lo_list.find(item => Number(item.id) === Number(lo_id));

      if (isCourseCompleted && !lo_id) {
        const first = lo_list[0];
        setSelectedLO(first);
        pushUrl(`${routes.academy.path}/${course_id}/${first?.id}`);
      } else if (selectedFromUrl && !selectedFromUrl.blocked) {
        setSelectedLO(selectedFromUrl);
      } else if (selectedFromUrl && selectedFromUrl.blocked) {
        const firstAvailable = lo_list.find(lo => lo.status !== 'completed' && lo.status !== 'passed') ?? lo_list[0];
        setSelectedLO(firstAvailable);
        if (firstAvailable) pushUrl(`${routes.academy.path}/${course_id}/${firstAvailable.id}`);
      } else {
        const firstAvailable = lo_list.find(lo => lo.status !== 'completed' && lo.status !== 'passed') ?? lo_list[0];
        setSelectedLO(firstAvailable);
        if (firstAvailable) pushUrl(`${routes.academy.path}/${course_id}/${firstAvailable.id}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // views LO
  useEffect(() => {
    if (selectedLO && !(selectedLO?.user_actions?.views)) {
      setLOViews(selectedLO.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLO]);

  const onClickLOItem = (item) => {
    if (item?.blocked) return;
    setSelectedLO(item);
    pushUrl(`${routes.academy.path}/${course_id}/${item.id}`);
    // ricarico i dettagli per avere stato fresco
    getAcademyDetails(course_id);
  };

  const onClickNext = () => {
    const lo_list = Array.isArray(data?.lo_list) ? data.lo_list : [];
    const idx = lo_list.findIndex(lo => String(lo.id) === String(selectedLO?.id));
    const isLast = idx === lo_list.length - 1;

    if (!isLast) {
      const next = lo_list[idx + 1];
      if (next) pushUrl(`${routes.academy.path}/${course_id}/${next.id}`);
    } else {
      const first = lo_list[0];
      if (first) pushUrl(`${routes.academy.path}/${course_id}/${first.id}`);
    }
    getAcademyDetails(course_id);
  };

  const calcPercentage = (items = []) => {
    const list = Array.isArray(items) ? items : [];
    const completed = list.reduce(
      (acc, item) => acc + ((item.status === 'completed' || item.status === 'passed') ? 1 : 0),
      0
    );
    const total = list.length || 1;
    return (completed * 100) / total;
  };

  const handleOnclickLikeDislike = (action_type) => {
    if (!selectedLO) return;
    if ((action_type === 'like' && selectedLO?.user_actions?.like) ||
        (action_type === 'dislike' && selectedLO?.user_actions?.dislike)) return;
    setLikeDislike({ nid: selectedLO.id, action_type });
  };

  const handleOnSubmitComment = (value) => {
    if (!selectedLO) return;
    setComment({
      id: selectedLO?.id,
      subject: selectedLO?.title,
      comment_body: value,
    });
  };

  return (
    <ProductCoursesContainer arabic={isArabic()}>
      <Container className="p-0">
        <BackButton url={routes.academy.path} />
        {(!contentNotAvailable && showCourse) ? (
          <>
            <HeaderContainer>
              <HeaderInfoContainer>
                <Info>
                  {data?.category && (
                    <Category>
                      <Arial type="categoryPill">{data.category.name}</Arial>
                    </Category>
                  )}
                  {data?.expire_date ? (
                    <ExpireDate>
                      <Arial type="courseExpireDate">
                        { isArabic() ? (
                          `${dateFormat(
                            data.expire_date,
                            '',
                            getValueVocabulary(vocabulary.dateFormat, 'dateFormat')
                          )} :${getValueVocabulary(vocabulary.expireDate, 'expireDate')}`
                        ) : (
                          `${getValueVocabulary(vocabulary.expireDate, 'expireDate')}: ${
                            dateFormat(
                              data.expire_date,
                              '',
                              getValueVocabulary(vocabulary.dateFormat, 'dateFormat')
                            )
                          }`
                        )}
                      </Arial>
                    </ExpireDate>
                  ) : null}
                </Info>
                <SocialTitle>
                  <Arial type="collectionHeaderTitle">{data?.title}</Arial>
                </SocialTitle>
              </HeaderInfoContainer>

              <ProgressContainer>
                <ProgressWrapper>
                  <Arial type="progressInfo">{getValueVocabulary(vocabulary.completion, 'completion')}</Arial>
                  <Arial type="progressInfo">{calcPercentage(data?.lo_list).toFixed(0)}%</Arial>
                </ProgressWrapper>
                <ProgressBar state="academy" percentage={calcPercentage(data?.lo_list)} />
              </ProgressContainer>
            </HeaderContainer>

            <MainSection>
              <Row className={isArabic() && 'd-flex flex-row-reverse'}>
                <Col sm={12} md={data?.lo_list?.length > 1 ? 8 : 12} lg={data?.lo_list?.length > 1 ? 8 : 12}>
                  {selectedLO ? (
                    <>
                      <VideoContainer>
                        {scormFullscreen ? (
                          <Frame>
                            <Arial type="editorialCardText" vocabulary="fullScreenMode">
                              {getValueVocabulary(vocabulary.fullScreenMode, 'fullScreenMode')}
                            </Arial>
                          </Frame>
                        ) : (
                          <Iframe
                            title={selectedLO?.title}
                            src={selectedLO?.content}
                            id="scorm_frame"
                            onLoad={() => setScormFrameIsLoaded(true)}
                          />
                        )}
                      </VideoContainer>

                      <VideoInfo>
                        <ButtonContainer>
                          {Array.isArray(data?.lo_list) && data.lo_list.length > 1 && (
                            <Button
                              type="academy"
                              btnText={getValueVocabulary(vocabulary.btnNext, 'btnNext')}
                              onClick={onClickNext}
                              height={20}
                            />
                          )}
                        </ButtonContainer>

                        <VideoInfoWrapper>
                          <Arial type="sectionTitle">{selectedLO?.title}</Arial>
                          <Social socialTop>
                            <span className="icon-visualizzazioni" />
                            <span style={{ fontSize: 12, color: 'white', marginTop: '2px' }}>
                              {selectedLO?.views}
                            </span>
                          </Social>
                        </VideoInfoWrapper>

                        <Description title={selectedLO?.description?.replace(/<[^>]*>/g, '')}>
                          <Arial type="description14">
                            <HtmlRaw html={selectedLO?.description || ''} />
                          </Arial>
                        </Description>

                        <VideoSocialWrapper>
                          <Like>
                            <Social
                              isActive={selectedLO?.user_actions?.like}
                              onClick={() => { if (!selectedLO?.user_actions?.like) handleOnclickLikeDislike('like'); }}
                            >
                              <span className="icon-like" />
                              <Arial type="like">
                                {selectedLO?.like}
                              </Arial>
                            </Social>
                            <Social
                              isActive={selectedLO?.user_actions?.dislike}
                              onClick={() => { if (!selectedLO?.user_actions?.dislike) handleOnclickLikeDislike('dislike'); }}
                            >
                              <span className="icon-nonutile" />
                              <Arial type="like">
                                {selectedLO?.dislike}
                              </Arial>
                            </Social>
                          </Like>
                        </VideoSocialWrapper>
                      </VideoInfo>

                      <Comments
                        type="academy"
                        list={selectedLO?.comments}
                        onSubmit={handleOnSubmitComment}
                      />
                    </>
                  ) : null}
                </Col>

                {Array.isArray(data?.lo_list) && data.lo_list.length > 1 && (
                  <Col sm={12} md={4} lg={4}>
                    <ProductCoursesListContainer>
                      <ProductCourseHeader>
                        <ProductCourseHeaderLength>
                          <ProductCoursesListCount>
                            <Arial type="coursesHeaderLengthBold">{data?.lo_list?.length}</Arial>
                            <Arial type="coursesHeaderLength" vocabulary="totalLearningObject">
                              {getExactLabel(vocabulary, data?.lo_list?.length, 'totalLearningObject', 'totalLearningObjects')}
                            </Arial>
                          </ProductCoursesListCount>

                          <ProductCourseHeaderDuration>
                            <ProductCourseClock className="icon-clock" />
                            <Arial configuration={{ size: 10 }}>
                              { isArabic()
                                ? `${getValueVocabulary(vocabulary.courseDetailDuration, 'courseDetailDuration')} ${durationConvert(data?.duration)}`
                                : `${durationConvert(data?.duration)} ${getValueVocabulary(vocabulary.courseDetailDuration, 'courseDetailDuration')}`
                              }
                            </Arial>
                          </ProductCourseHeaderDuration>
                        </ProductCourseHeaderLength>
                      </ProductCourseHeader>

                      <ProductCourseList>
                        {scormFrameIsLoaded && data.lo_list.map(item => (
                          <LearningObjectCard
                            key={item.code ?? item.id}
                            item={item}
                            label={getValueVocabulary(vocabulary.videoDurationMin, 'videoDurationMin')}
                            isActive={String(item?.id) === String(selectedLO?.id)}
                            onClick={() => onClickLOItem(item)}
                            arabic={isArabic()}
                          />
                        ))}
                      </ProductCourseList>
                    </ProductCoursesListContainer>
                  </Col>
                )}
              </Row>
            </MainSection>
          </>
        ) : (
          <CourseNotAvailable>
            <Arial
              type="sectionNotificationTitle"
              configuration={{ textAlign: 'center' }}
              vocabulary="contentNotAvailableMessage"
            >
              {getValueVocabulary(vocabulary.contentNotAvailableMessage, 'contentNotAvailableMessage')}
            </Arial>
          </CourseNotAvailable>
        )}
      </Container>
    </ProductCoursesContainer>
  );
};

AcademyDetails.propTypes = {
  course_id: PropTypes.string.isRequired,
  lo_id: PropTypes.string,
  course_details: PropTypes.object.isRequired,
  vocabulary: PropTypes.object.isRequired,
  contentNotAvailable: PropTypes.bool,
  location: PropTypes.string,
  getAcademyDetails: PropTypes.func.isRequired,
  resetAcademyDetails: PropTypes.func.isRequired,
  setLikeDislike: PropTypes.func.isRequired,
  setAcademyDetailsCourseViews: PropTypes.func.isRequired,
  setLOViews: PropTypes.func.isRequired,
  setComment: PropTypes.func.isRequired,
  pushUrl: PropTypes.func.isRequired,
};

export default connect(
  state => {
    const { selectedAcademy: course_details, contentNotAvailable } = state.academy;
    const { vocabulary } = state.app;
    const { pathname: location } = state.router.location;
    return { course_details, vocabulary, contentNotAvailable, location };
  },
  dispatch => ({
    getAcademyDetails: id => dispatch({ type: ACADEMY_DETAILS_GET._REQUEST, id }),
    resetAcademyDetails: () => dispatch({ type: ACADEMY_LO_UNSET._SUCCESS }),
    setLikeDislike: ({ nid, action_type }) => dispatch({ type: ACADEMY_LO_SET_LIKEDISLIKE._REQUEST, nid, action_type }),
    setAcademyDetailsCourseViews: (nid) => dispatch({ type: ACADEMY_COURSE_DETAILS_SET_VIEWS._REQUEST, nid }),
    setLOViews: (nid) => dispatch({ type: ACADEMY_LO_SET_VIEWS._REQUEST, nid }),
    setComment: (body) => dispatch({ type: ACADEMY_LO_SET_COMMENT._REQUEST, body }),
    pushUrl: url => dispatch(push(url)),
  })
)(AcademyDetails);
